import { useQuery } from "@tanstack/react-query";
import { Issuer, IssuersService } from "api/generated/cms";
import { CMS_QUERY_OPTIONS } from "./cmsQueryOptions";
import "./cmsClient";

const fetchIssuers = (): Promise<Issuer[]> =>
  IssuersService.getApiV1Issuers({});

export const useGetCmsIssuers = () => {
  const { isInitialLoading, error, data } = useQuery<Issuer[], Error>(
    ["cms", "issuers"],
    fetchIssuers,
    CMS_QUERY_OPTIONS
  );
  return { loading: isInitialLoading, error, data };
};
